import CreateAttachment from "./CreateAttachment";
import FileImportError from "./FileImportError";
import EditAttachment from "./EditAttachment";
import CreatePractice from "./CreatePractice";

const Dialogs  = {
    CreateAttachment,
    FileImportError,
    EditAttachment,
    CreatePractice,
}
export default Dialogs;